import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RangeForm from '../rangeForm.vue'
import MultipleInput from '@/utils/MultipleInputs'
import { hasValue } from '@/utils/util'

const WEI_JUE = '11',
	FU_KAN = '22'
const MAX_PENDING = 20,
	MAX_RESURVEY = 20
const ruleTypeList = [
	{
		label: '未决回访',
		value: WEI_JUE,
	},
	{
		label: '住院复勘',
		value: FU_KAN,
	},
]

@Component({
	components: {
		RangeForm,
	},
})
export default class RuleForm extends Vue {
	public secMulti: any = {}
	public ruleTypeList = ruleTypeList
	public WEI_JUE = WEI_JUE
	public FU_KAN = FU_KAN
	public subForm: any = {}

	@Prop({})
	public data!: any

	public addSec() {
		this.secMulti.add()
	}

	public removeSec(index: number) {
		this.secMulti.remove(index)
	}

	public getRuleList() {
		return new Promise((resolve, reject) => {
			let count = 0,
				list: any[] = []
			this.secMulti.idArr.forEach((id: number) => {
				const rangeSec: any = ((this.$refs[`rangeForm${id}`] || []) as any[])[0]
				if (rangeSec) {
					rangeSec
						.getForm()
						.then((values: any) => {
							list.push(values)
							if (++count === this.secMulti.idArr.length) {
								return resolve(list)
							}
						})
						.catch((err: any) => {
							return reject(err)
						})
				} else {
					return reject()
				}
			})
		})
	}

	public getForm(): any {
		return new Promise((resolve, reject) => {
			resolve()
		})
	}

	public created() {
		this.subForm = this.$form.createForm(this)
		this.secMulti = new MultipleInput(1, MAX_PENDING)
	}
}
